import React from 'react';
import { Row, Col, Input, Select, Button, Space, Card, Statistic } from 'antd';
import { SearchOutlined, ClearOutlined, ReloadOutlined } from '@ant-design/icons';
import { getCategoryDisplayName } from '../../../hooks/useUnits';

const { Option } = Select;

/**
 * UnitsFilters Component
 * ส่วนค้นหาและกรองข้อมูลหน่วยนับ
 */
const UnitsFilters = ({
  filters,
  categories,
  statistics,
  loading,
  onFilterChange,
  onReset,
  onRefresh
}) => {
  /**
   * จัดการการค้นหา
   */
  const handleSearch = (value) => {
    onFilterChange({ search: value });
  };

  /**
   * จัดการการกรองตาม category
   */
  const handleCategoryFilter = (value) => {
    onFilterChange({ category: value || '' });
  };

  /**
   * จัดการการกรองตาม status
   */
  const handleStatusFilter = (value) => {
    onFilterChange({ is_active: value });
  };

  /**
   * รีเซ็ตฟิลเตอร์ทั้งหมด
   */
  const handleReset = () => {
    onReset();
  };

  return (
    <div style={{ marginBottom: 24 }}>
      {/* สถิติ */}
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col xs={12} sm={6}>
          <Card size="small">
            <Statistic
              title="ทั้งหมด"
              value={statistics.total}
              valueStyle={{ color: '#1890ff', fontSize: '20px' }}
            />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card size="small">
            <Statistic
              title="ใช้งาน"
              value={statistics.active}
              valueStyle={{ color: '#52c41a', fontSize: '20px' }}
            />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card size="small">
            <Statistic
              title="ไม่ใช้งาน"
              value={statistics.inactive}
              valueStyle={{ color: '#ff4d4f', fontSize: '20px' }}
            />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card size="small">
            <Statistic
              title="หมวดหมู่"
              value={statistics.categories}
              valueStyle={{ color: '#722ed1', fontSize: '20px' }}
            />
          </Card>
        </Col>
      </Row>

      {/* ฟิลเตอร์ */}
      <Card size="small" title="ค้นหาและกรองข้อมูล">
        <Row gutter={[16, 16]}>
          {/* ช่องค้นหา */}
          <Col xs={24} sm={8} md={6}>
            <Input.Search
              placeholder="ค้นหาชื่อหน่วยหรือรหัส..."
              value={filters.search}
              onChange={(e) => handleSearch(e.target.value)}
              onSearch={handleSearch}
              allowClear
              prefix={<SearchOutlined />}
              style={{ width: '100%' }}
            />
          </Col>

          {/* กรองตามหมวดหมู่ */}
          <Col xs={24} sm={8} md={6}>
            <Select
              placeholder="เลือกหมวดหมู่"
              value={filters.category || undefined}
              onChange={handleCategoryFilter}
              allowClear
              style={{ width: '100%' }}
              showSearch
              optionFilterProp="children"
            >
              {categories.map(cat => (
                <Option key={cat.category} value={cat.category}>
                  {getCategoryDisplayName(cat.category)} ({cat.active_count}/{cat.count})
                </Option>
              ))}
            </Select>
          </Col>

          {/* กรองตามสถานะ */}
          <Col xs={24} sm={8} md={6}>
            <Select
              placeholder="เลือกสถานะ"
              value={filters.is_active}
              onChange={handleStatusFilter}
              allowClear
              style={{ width: '100%' }}
            >
              <Option value={true}>ใช้งาน</Option>
              <Option value={false}>ไม่ใช้งาน</Option>
            </Select>
          </Col>

          {/* ปุ่มจัดการ */}
          <Col xs={24} sm={24} md={6}>
            <Space style={{ width: '100%' }} wrap>
              <Button 
                onClick={handleReset}
                icon={<ClearOutlined />}
                disabled={loading}
              >
                ล้างตัวกรอง
              </Button>
              <Button 
                onClick={onRefresh}
                icon={<ReloadOutlined />}
                loading={loading}
              >
                รีเฟรช
              </Button>
            </Space>
          </Col>
        </Row>

        {/* แสดงสถานะ filter ปัจจุบัน */}
        {(filters.search || filters.category || filters.is_active !== null) && (
          <div style={{ marginTop: 12, padding: '8px 12px', background: '#f0f0f0', borderRadius: 4 }}>
            <Space wrap>
              <span style={{ fontWeight: 500, color: '#666' }}>กำลังกรอง:</span>
              
              {filters.search && (
                <span style={{ color: '#1890ff' }}>
                  ค้นหา: "{filters.search}"
                </span>
              )}
              
              {filters.category && (
                <span style={{ color: '#1890ff' }}>
                  หมวดหมู่: {getCategoryDisplayName(filters.category)}
                </span>
              )}
              
              {filters.is_active !== null && (
                <span style={{ color: '#1890ff' }}>
                  สถานะ: {filters.is_active ? 'ใช้งาน' : 'ไม่ใช้งาน'}
                </span>
              )}
            </Space>
          </div>
        )}
      </Card>
    </div>
  );
};

export default UnitsFilters;